import { createStyles, rem } from '@mantine/styles';

var useStyles = createStyles({
  dropdown: { padding: rem(4) }
});

export default useStyles;
//# sourceMappingURL=Menu.styles.js.map
